webpackJsonp([228644653637584],{

/***/ 1105:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0003_playful_panda.jpg","type":"Unit","subtype":"Panda","cost":2,"ATK":2,"HP":2,"rules_text_1":"Arrives: Exhausted. Summon a 0/1 green Wisp token.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Playful Panda","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"Wisps follow those who are pure of heart.","color":"Green","spec":null,"bottom":"Tech 0","rulings":[],"keywords":[],"slug":"playful_panda"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"playful_panda","keywords":[],"imageRegex":"/playful_panda.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-playful-panda-97f444a56add8c56d48f.js